import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api/client';

/** Identidade do usuário autenticado — espelha o GetMeResponse do backend (GET /api/me). */
export interface Me {
  userId: string;
  email: string;
  name: string;
  role: string;
  isAdmin: boolean;
  locale: string;
}

/**
 * Busca a identidade do usuário autenticado. Só dispara quando `enabled` (logado),
 * para não chamar a API sem token.
 */
export function useMe(enabled: boolean) {
  return useQuery({
    queryKey: ['me'],
    queryFn: () => apiFetch<Me>('/api/me'),
    enabled,
  });
}
